import { Service } from '@timing71/common';

import { Client, RedirectError } from './client.js';

export class Natsoft extends Service {

  constructor(...args) {
    super(...args);
    this._socket = null;

    this.wsURL = this.service.source.replace(/^t71 Natsoft:\/\//i, '').replace(/^http(s?):/, 'ws\$1:');
    this._tag = this.service.uuid;
    this._reconnect_count = 0;
  }

  start(connectionService) {
    super.start(connectionService);

    this._client = new Client(
      connectionService.createDOMParser(),
      this.onStateChange,
      this.onManifestChange,
      this.onSessionChange
    );

    this._doConnect = this._doConnect.bind(this);
    this._doConnect(connectionService);

  }

  _doConnect(connectionService) {
    try {
      this._socket = connectionService.createWebsocket(
        this.wsURL,
        {
          autoReconnect: false,
          tag: this._tag
        }
      );
      this._socket.onopen = () => {
        this.emitInfo('Service connected', 'Connected to upstream data source');
      }

      this._socket.onclose = () => {
        this.emitWarning('Service disconnected', 'Disconnected from upstream data source, trying to reconnect...');
        this._reconnTimeout = setTimeout(() => this._doConnect(connectionService), 2000);
      }
      this._socket.onmessage = (m) => {
        try {
          if (m.data) {
            this._client.handlePacket(m.data);
          }
          else if (typeof(m.toString) === 'function') {
            this._client.handlePacket(m.toString());
          }
        }
        catch (err) {
          if (err instanceof RedirectError) {
            this.wsURL = err.url.replace(/^https?:/, 'ws:');
            this._socket.close();
            this._tag = `${this.service.uuid}:${++this._reconnect_count}`;
            this.start(connectionService);
          }
        }
      };
    }
    catch {
      // For whatever reason, WS connection failed...
      if (!this._reconnTimeout) {
        this.emitError('Connection failed', 'Failed to connect to timing service. Trying again in 2 seconds...', 2000);
        this._reconnTimeout = setTimeout(() => this._doConnect(connectionService), 2000);
      }
    }
  }

  stop() {
    this._socket && this._socket.close();
    this._reconnTimeout && clearTimeout(this._reconnTimeout);
  }

}

Natsoft.regex = /\/LiveMeeting\//; // Ick, this is a bit tentative...
